/* global google */

import React from 'react';
import PropTypes from 'prop-types';
import loadGoogleMapsAPI from 'load-google-maps-api';
import mapOptions from './GoogleMap/mapOptions';
import { setMarkers } from './GoogleMap/mapMarkers';


class Map extends React.Component {
    constructor(props) {
        super(props);
        this.initMap  = this.initMap.bind(this);
        this.showMap  = this.showMap.bind(this);
        this.map      = null;
        this.mapMarkers = null;
    }

    componentDidMount() {
        this.initMap();
    }

    componentDidUpdate() {
        this.showMap();
    }

    initMap() {
        if (typeof google !== 'undefined') {
            this.showMap();
            return;
        }
        loadGoogleMapsAPI({
            key: 'AIzaSyARHfNm86RrNT4tbsrzXGgT7gylkeSl6-M',
            libraries: 'geometry'
        }).then(this.showMap).catch((err) => {
            //console.log('Could not load maps api');
        });

        const container = document.getElementById('map-wrapper');
        if (container) {
            container.addEventListener('openmap', e => {
                this.targetSchool(e.detail.schoolId);
            }, false);
            container.addEventListener('closemap', e => {
                this.untargetSchools();
            }, false);
        }
    }

    showMap() {
        const domMap       = document.getElementById('map');
        this.map           = new google.maps.Map(domMap, mapOptions);

        if (this.props.schools.length === 1) {
            let center = new google.maps.LatLng(this.props.schools[0].lat, this.props.schools[0].lng);
            this.map.setCenter(center);
            this.map.setZoom(6);
        } else {
            const bounds = new google.maps.LatLngBounds();
            this.props.schools.map((school) => {
                bounds.extend(new google.maps.LatLng(school.lat, school.lng));
            });

            this.map.fitBounds(bounds);
        }

        this.mapMarkers = setMarkers(this.props.schools, this.map);
    }

    targetSchool(schoolId) {
        for (const school of this.mapMarkers) {
            if (school.id == schoolId) {
                const icon = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#210727',
                    fillOpacity: 1,
                    scale: 8,
                    strokeWeight: 1,
                    strokeColor: '#826987',
                };
                school.setIcon(icon);
                // without the timeout the zoom doesn't work the first time, might be a smarter way to do this
                setTimeout(() => {
                    this.map.setCenter(school.position);
                    this.map.setZoom(7);
                }, 100);
            }
        }
    }

    untargetSchools() {
        const bounds = new google.maps.LatLngBounds();
        this.props.schools.map((school) => {
            bounds.extend(new google.maps.LatLng(school.lat, school.lng));
        });

        this.map.fitBounds(bounds);

        for (const school of this.mapMarkers) {
            const icon = {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: '#826987',
                fillOpacity: 0.8,
                scale: 4,
                strokeWeight: 0,
            };
            school.setIcon(icon);
        }
    }

    render() {
        return (
            <div className="map__container-wrapper" id="map-wrapper">
                <div id="map" className="map"></div>
            </div>
        );
    }
}

Map.propTypes = {
    schools: PropTypes.array,
};

export default Map;
